import { Routes } from '@angular/router';

export const FAQS_ROUTES: Routes = [
  {
    path: 'faqs',
    loadComponent: () =>
      import('./faqs-list/faqs-list.component')
        .then(m => m.FaqsListComponent),
  }
];
